import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import LoadingButton from "../../components/LoadingButton"
import Button from "@material-ui/core/Button"
import {
  toggleAddClientDialog,
  toggleDeleteClientDialog,
  createClient,
  updateClient,
  deleteClient,
  _setEditClient,
  getClientList,
  toggleAddClientCompanyDialog,
} from "../../actions/clients"

import { isEmpty, pickBy, isNil } from "lodash"
import update from "immutability-helper"
import Input from "@material-ui/core/Input"
import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel"

import FormHelperText from "@material-ui/core/FormHelperText"
import Grid from "@material-ui/core/Grid"
import { openSnackBar } from "../../actions/snack-bar"
import IconButton from "@material-ui/core/IconButton"
import Checkbox from "@material-ui/core/Checkbox"
import Paper from "@material-ui/core/Paper"

import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"

import TextField from "@material-ui/core/TextField"
import classNames from "classnames"
import Moment from "moment"
import PhoneInput from "../PhoneInput"
import { parseNumber } from "libphonenumber-js"
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined"
import CircularProgress from "@material-ui/core/CircularProgress"
import { uploadFile } from "../../actions/misc"
import Avatar from "@material-ui/core/Avatar"
import AddPhotoAlternate from "@material-ui/icons/AddAPhoto"
import "react-image-gallery/styles/css/image-gallery.css"
import AutoComplete from "../AutoComplete"
import Chip from '@material-ui/core/Chip';




const defaultState = {
  client: {
    first_name: "",
    last_name: "",
    client: "",
    phone: "",
    email: "",
    gtt: false,
    ad: false,
    logo_image: null,
    company_id: null,
  },
  newNote: "",
  savingProfile: false,
  selectedCountry: "US",
  uploadingAvatar: false,
  tempImageData: null,
  clientCompany: null,

  clientCompanies: [],
  activeCheck: false


}
class AddClientDialog extends Component {
  constructor(props) {
    super(props)

    this.state = defaultState
  }



  handleClose = () => {
    this.props.dispatch(toggleAddClientDialog(false))
    this.props.dispatch(_setEditClient())
  }
  clearState = () => {
    this.setState(defaultState)
  }
  setUpForm = () => {

    const { client, companyList } = this.props


    const form = document.getElementById("edit-form-client")
    const inputs = form.querySelectorAll("input, textarea")
    let newState = update(this.state, {})
    if (!newState.form) {
      newState.form = {}
    }
    for (let i = 0; i < inputs.length; ++i) {
      newState.form[inputs[i].name] = { validity: inputs[i].validity }
    }
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
    if (!isEmpty(client)) {
      let foundCompany =
        !isEmpty(companyList) && client && client.company_id
          ? companyList.find(cl => cl.id === client.company_id)
          : null

      // let found = client.companyList.find(item => item.default)


      this.setState({
        client: {
          first_name: client.first_name,
          last_name: client.last_name,
          client: client.client,
          phone: client.phone,
          email: client.email,
          gtt: client.gtt == 1 ? true : false,
          ad: client.ad == 1 ? true : false,
          logo_image: client.logo_image,
          company_id: client.company_id,
        },
        newNote: client.notes,
        clientCompany: foundCompany,
        clientCompanies: client.companyList
      })
    }
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value
    const validity = e.target.validity

    let newState = update(this.state, {
      client: {
        [fieldName]: { $set: value },
      },
      form: {
        [fieldName]: {
          validity: { $set: validity },
        },
      },
    })
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
  }
  handleChangeCheckbox = event => {
    let newState = update(this.state, {
      client: {
        [event.target.name]: { $set: event.target.checked },
      },
    })
    this.setState(newState)
  }
  handlePhoneChange = value => {
    let validity = document.getElementById("phoneInput").validity
    if (value) {
      validity.phone = !isEmpty(parseNumber(value, this.state.selectedCountry))
    } else {
      validity.phone = false
    }

    let newState = update(this.state, {
      client: {
        phone: { $set: value ? value : "" },
      },
      form: {
        phone: {
          validity: { $set: validity },
        },
      },
    })
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
  }
  handleCountryChange = country => {
    this.setState({ selectedCountry: country })
  }
  handleInputBlur = e => {
    const fieldName = e.target.name

    let newState = update(this.state, {
      form: {
        [fieldName]: {
          touched: { $set: true },
        },
      },
    })
    this.setState(newState)
  }
  handlePhoneBlur = e => {
    this.setState(
      update(this.state, {
        form: {
          phone: {
            touched: { $set: true },
          },
        },
      })
    )
  }
  fieldIsValid = inputName => {
    if (!isEmpty(this.state.form)) {
      if (this.state.form[inputName].touched) {
        if (inputName === "phone") {
          return (
            this.state.form[inputName].validity.valid &&
            this.state.form[inputName].validity.phone
          )
        } else {
          return this.state.form[inputName].validity.valid
        }
      } else {
        return true
      }
    } else {
      return true
    }
  }
  formIsValid = form => {
    let formValidArray = []
    for (let key in form) {
      if (key !== "valid") {
        formValidArray.push(form[key].validity.valid)
      }
    }
    return formValidArray.indexOf(false) === -1
  }
  pushNote = () => {
    this.setState(
      update(this.state, {
        client: {
          notes: {
            $push: [
              {
                note: this.state.newNote,
              },
            ],
          },
        },
        newNote: {
          $set: "",
        },
      })
    )
  }



  submit = () => {
    const { client, clientList, authenticatedUser } = this.props
    const { tempImageData } = this.state
    this.setState({
      savingProfile: true,
    })

    let clientCheck = clientList.find(c => c.hasOwnProperty("email") && c.email !== null && c.email.toLowerCase() === this.state.client.email.toLowerCase())

    let defaultCompany = this.state.clientCompanies.find((item) => item.default)
    let clientCompaniesList = this.state.clientCompanies.filter((item) => !item.default).map((item) => { return ({ company_id: item.id, client_id: client.id, creator_id: authenticatedUser.id }) })
    const data = pickBy(this.state.client, val => !isEmpty(val))
    data.company_id = defaultCompany ? defaultCompany.id : null
    data.gtt = this.state.client.gtt == true ? 1 : 0
    data.ad = this.state.client.ad == true ? 1 : 0
    data.notes = this.state.newNote
    data.clientCompanies = clientCompaniesList

    if (!isEmpty(client)) {
      data.logo_image = tempImageData
    }

    if (!isEmpty(client) && client.id) {

      this.props
        .dispatch(
          updateClient(
            {
              ...data,
            },
            client.id,
            client.company_id
          )
        )
        .then(res => {
          this.props.dispatch(
            openSnackBar({
              message: res.message,
            })
          )
          this.props.dispatch(getClientList()).then(() => {
            this.setState({ savingProfile: false })
            this.props.dispatch(toggleAddClientDialog(false))
            this.props.dispatch(_setEditClient())
          }).catch((err) => {
            this.setState({ savingProfile: false })
            this.props.dispatch(toggleAddClientDialog(false))
            this.props.dispatch(_setEditClient())
          })

        })
        .catch(err => {
          this.setState({
            savingProfile: false,
          })
          this.props.dispatch(
            openSnackBar({
              message: "There was an unknown error",
            })
          )
          return
        })
    } else {
      if (clientCheck) {
        this.setState({
          savingProfile: false,
        })
        this.props.dispatch(
          openSnackBar({
            message: "Email Already Exists",
          })
        )
        return
      }

      this.props
        .dispatch(
          createClient({
            ...data,
          })
        )
        .then(res => {

          this.props.dispatch(
            openSnackBar({
              message: res.message,
            })
          )


          this.props.dispatch(getClientList()).then(() => {
            this.setState({
              savingProfile: false,
            })
            this.props.dispatch(toggleAddClientDialog(false))
          }).catch((err) => {
            this.setState({
              savingProfile: false,
            })
            this.props.dispatch(toggleAddClientDialog(false))
          })


        })
        .catch(err => {

          this.setState({
            savingProfile: false,
          })
          this.props.dispatch(
            openSnackBar({
              message: "There was an unknown error",
            })
          )
          return
        })
    }
  }


  selectAndAddCompany = company => {
    const { companyList } = this.props
    let foundCompany = !isEmpty(companyList)
      ? companyList.find(cl => cl.id === company)
      : null
    if (company) {
      if (typeof company === "number" && foundCompany) {
        this.setState(
          update(this.state, {
            client: {
              company_id: { $set: company },
            },
            clientCompany: { $set: foundCompany },
          })
        )
        let companyObject = {
          id: foundCompany.id, label: foundCompany.name
        }

        let exist = this.state.clientCompanies.find(item => item.id === foundCompany.id);
        if (!exist) {
          this.setState(prevState => ({
            clientCompanies: [...prevState.clientCompanies, companyObject]
          }))
        }
        setTimeout(() => {
          this.setState(
            update(this.state, {
              activeCheck: { $set: false },

            })
          )
        }, 500);
      } else {
        this.props.dispatch(toggleAddClientCompanyDialog(true))
      }
    } else {
      this.setState(
        update(this.state, {
          client: {
            company_id: { $set: null },
          },
          clientCompany: { $set: foundCompany },

        })
      )
      setTimeout(() => {
        this.setState(
          update(this.state, {
            activeCheck: { $set: false },

          })
        )
      }, 500);
    }

  }



  deleteClient = async () => {
    await this.props.dispatch(toggleAddClientDialog(false))
    await this.props.dispatch(toggleDeleteClientDialog(true))
  }

  avatarChanged = e => {
    const { client } = this.props
    const file = e.target.files[0]
    this.setState({ uploadingAvatar: true })
    this.props
      .dispatch(uploadFile(file, `clients/${client.id}/profile_images`))
      .then(image => {
        if (!isEmpty(client) && client.id) {
          this.props
            .dispatch(
              updateClient(
                {
                  logo_image: JSON.stringify(image),
                },
                client.id
              )
            )
            .then(() => {
              client.logo_image = JSON.stringify(image)
              this.setState({ tempImageData: JSON.stringify(image) })
              this.props.dispatch(_setEditClient(client))
              // dynamic update client without closing dialog
              this.setState({ uploadingAvatar: false })
              document.getElementById("logoImage").value = ""
            })
            .catch(err => {
              this.props.dispatch(
                openSnackBar({
                  message: "There was an error saving avatar",
                })
              )
              this.setState({ uploadingAvatar: false })
              document.getElementById("logoImage").value = ""
            })
        } else {
          client.logo_image = JSON.stringify(image)
          this.setState({ tempImageData: JSON.stringify(image) })
          this.props.dispatch(_setEditClient(client))
          // dynamic update client without closing dialog
          this.setState({ uploadingAvatar: false })
          document.getElementById("logoImage").value = ""
        }
      })
      .catch(err => {
        this.setState({ uploadingAvatar: false })
        document.getElementById("logoImage").value = ""
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving avatar",
          })
        )
      })
  }

  generateAvatar = () => {
    const { client } = this.props
    if (client.logo_image) {
      return (
        <img
          className={this.props.classes.avatarImage}
          src={`https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
            }/image/upload/c_thumb,g_face:auto,z_0.7,h_400,w_400,fl_lossy,f_auto/v${JSON.parse(client.logo_image).version
            }/${JSON.parse(client.logo_image).public_id}.${JSON.parse(client.logo_image).format
            }`}
          alt={`${client.first_name} ${client.last_name}`}
        />
      )
    } else {
      return (
        <Avatar className={this.props.classes.avatar}>
          {!isEmpty(client)
            ? `${client.first_name.charAt(0)} ${client.last_name.charAt(0)}`
            : ""}
        </Avatar>
      )
    }
    // }
  }

  handelAddClientCompany = (e) => {
    if (!("default" in e)) {
      let filterComapniesList = this.state.clientCompanies.map((item) => {
        return item.id === e.id ? {
          id: item.id,
          label: item.label,
          default: true
        } : {
          id: item.id,
          label: item.label,
        }
      });
      this.setState({ clientCompanies: filterComapniesList })
    }
  }

  handleDeleteCompany = (e) => {

    let filterComapniesList = this.state.clientCompanies.filter((item) => item.id !== e.id)
    this.setState({ clientCompanies: filterComapniesList })

  }


  handelAutoCompletBlur = () => {
    setTimeout(() => {
      this.setState(
        update(this.state, {
          activeCheck: { $set: false },
        })
      )
    }, 500);

  }

  handelAutoChange = (e) => {
    this.setState(
      update(this.state, {
        activeCheck: { $set: true },
      })
    )
  }

  render() {
    const { fullScreen, classes, client, companyList } = this.props
    const { clientCompany } = this.state
    return (
      <Dialog
        className={classes.profileDialog}
        fullScreen={fullScreen}
        open={this.props.addClientDialogOpen}
        onClose={this.handleClose}
        onEntered={this.setUpForm}
        onExited={this.clearState}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          classes: {
            root: classes.dialogPaper,
          },
        }}
      >
        <form id="edit-form-client" noValidate autoComplete="off">
          <DialogTitle disableTypography className={classes.dialogTitle}>
            {!isEmpty(client) &&
              client.email && (
                <Typography className={classes.textColor} variant="h6">{`Edit ${client.first_name
                  } ${client.last_name}`}</Typography>
              )}
            {(isEmpty(client) || (!isEmpty(client) && !client.id)) && (
              <Typography className={classes.textColor} variant="h6">
                {"New Client"}
              </Typography>
            )}
            <IconButton
              className={classes.closeButton}
              onClick={this.handleClose}
              aria-label="Close"
            >
              <CloseIcon classes={{ root: classes.closeIcon }} />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={5} className={classes.backgroundDim}>
                <FormControl fullWidth className={classes.paddingTop}>
                  <InputLabel htmlFor="first_name">First Name</InputLabel>
                  <Input
                    type="text"
                    fullWidth
                    name="first_name"
                    value={this.state.client.first_name}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputBlur}
                    id="first_name"
                    autoComplete="nope"
                    inputProps={{
                      required: true,
                    }}
                  />
                </FormControl>
                <FormControl fullWidth className={classes.paddingTop}>
                  <InputLabel htmlFor="last_name">Last Name</InputLabel>
                  <Input
                    type="text"
                    fullWidth
                    name="last_name"
                    value={this.state.client.last_name}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputBlur}
                    id="last_name"
                    autoComplete="nope"
                    inputProps={{
                      required: true,
                    }}
                  />
                </FormControl>

                <FormControl fullWidth className={classes.paddingTop}>
                  <InputLabel htmlFor="phone">Phone</InputLabel>
                  <Input
                    type="text"
                    fullWidth
                    name="phone"
                    value={this.state.client.phone}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputBlur}
                    id="phone"
                    autoComplete="nope"
                    inputProps={{
                      required: true,
                    }}
                  />
                </FormControl>

                {/* <PhoneInput
                  label="Phone Number*"
                  value={this.state.client.phone}
                  onChange={this.handlePhoneChange}
                  onBlur={this.handlePhoneBlur}
                  valid={this.fieldIsValid("phone")}
                  onCountryChange={this.handleCountryChange}
                /> */}

                <FormControl fullWidth>
                  <InputLabel htmlFor="email">Email *</InputLabel>
                  <Input
                    type="email"
                    fullWidth
                    name="email"
                    value={this.state.client.email}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputBlur}
                    id="email"
                    error={!this.fieldIsValid("email")}
                    autoComplete="nope"
                    inputProps={{
                      required: this.state.selectedCountry !== "US",
                    }}
                  />
                  <FormHelperText error id="email">
                    {!this.fieldIsValid("email") && <span>Enter email</span>}
                  </FormHelperText>
                </FormControl>

                <FormControl fullWidth className={classes.paddingTop}

                  style={{ zIndex: "400" }}
                  onChange={this.handelAutoChange}
                >
                  <AutoComplete
                    value={clientCompany ? clientCompany : null}
                    placeholder="Search Company"
                    onChange={value => this.selectAndAddCompany(value)}
                    labelKey="name"
                    showValue
                    backspaceRemovesValue
                    isClearable={true}
                    creatable={this.props.activeCompany}
                    formatCreateLabel={value => `Create new company`}
                    prop={this.props}
                    onBlur={this.handelAutoCompletBlur}

                  />
                </FormControl>
                <div
                  className={classes.paddingTopCheckbox}
                // style={{ paddingBottom: "30px", marginTop: "60px" }}

                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.client.gtt}
                        onChange={this.handleChangeCheckbox}
                        name="gtt"
                        className={classes.checkbox}
                        disabled={this.state.activeCheck}
                      />
                    }
                    label="GTT"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.client.ad == false ? false : true}
                        onChange={this.handleChangeCheckbox}
                        name="ad"
                        className={classes.checkbox}
                        disabled={this.state.activeCheck}

                      />
                    }
                    label="AD"
                  />
                </div>
                {!isEmpty(client) && (
                  <DeleteOutlinedIcon
                    style={{
                      color: "#dc004e",
                      cursor: "pointer",
                      position: "absolute",
                      left: "20",
                      bottom: "10",
                    }}
                    onClick={this.deleteClient}
                    aria-label="Close"
                  >
                    <CloseIcon classes={{ root: classes.closeIcon }} />
                  </DeleteOutlinedIcon>
                )}
              </Grid>
              <Grid item xs={12} sm={7}>
                <div
                  className={classNames(
                    classes.headlineWrapper,
                    classes.marginTop3
                  )}
                >
                  {!isEmpty(client) && (
                    <Typography variant="h5" className={classes.updateHeadline}>
                      last updated{" "}
                      {Moment(client.updated)
                        // .utc()
                        .from(Moment().subtract(5, "hours"))}
                    </Typography>
                  )}
                </div>
                <div
                  className={classNames(classes.noteArea, classes.marginTop3)}
                >
                  <div className={classes.notesInputWrapper}>
                    <TextField
                      value={this.state.newNote}
                      id="standard-basic"
                      placeholder="Add Notes"
                      type="text"
                      multiline
                      fullWidth
                      InputProps={{
                        classes: { underline: classes.noteInputUnderline },
                      }}
                      className={classes.noteInput}
                      onChange={e => this.setState({ newNote: e.target.value })}
                    />
                  </div>

                  <div>

                    {!isEmpty(this.state.clientCompanies) && <h4>Companies</h4>}
                    {
                      this.state.clientCompanies && this.state.clientCompanies.map((item, index) => {
                        return (
                          <Chip label={item.label} key={index}
                            className={classes.companiesChip}
                            color={item.default && "primary"}
                            onClick={() => this.handelAddClientCompany(item)}
                            onDelete={() => this.handleDeleteCompany(item)}
                          />
                        )
                      })
                    }

                  </div>




                  {/* <Paper eleation={2} className={classes.avatarPaper}>
                    <div
                      className={classNames(
                        classes.avatarWrapper,
                        classes.imageOverlay
                      )}
                    >
                      {this.state.uploadingAvatar && (
                        <div className={classes.avatarUploadOverlay}>
                          <CircularProgress
                            color="inherit"
                            className={classes.avatarUploadProgress}
                          />
                        </div>
                      )}
                      <label
                        htmlFor="logoImage"
                        className={classes.avatarLabel}
                      >
                        {!this.state.uploadingAvatar && (
                          <div className={classes.addImageOverlay}>
                            <AddPhotoAlternate
                              className={classes.addPhotoIcon}
                            />
                          </div>
                        )}
                        {this.generateAvatar()}
                        <input
                          type="file"
                          id="logoImage"
                          name="logoImage"
                          className={classes.avatarInput}
                          value={this.state.client.logoImage}
                          onChange={this.avatarChanged}
                        />
                      </label>
                    </div>
                  </Paper> */}
                </div>

                <DialogActions className={classes.dialogActions}>
                  <Button
                    variant="text"
                    color="secondary"
                    onClick={this.handleClose}
                  >
                    Close
                  </Button>
                  <LoadingButton
                    color="primary"
                    className={classes.button}
                    buttonclicked={this.submit}
                    working={
                      this.state.savingProfile || this.state.uploadingAvatar
                    }
                    disabled={this.state.client.email === ""}
                    type="button"
                  >
                    {!isEmpty(client) ? "Update" : "Save"}
                  </LoadingButton>
                </DialogActions>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    addClientDialogOpen: state.clients.addClientDialogOpen,
    user: state.users.editUser,
    client: state.clients.editClient,
    roles: state.misc.roles,
    locations: state.misc.locations,
    activeCompany: state.companies.activeCompany,
    createdClient: state.users.createdClient,
    createdCompany: state.clients.createdClientCompany,
    clientList: state.clients.clients,
    companyList: state.clients.companiesList,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true }),
  withMobileDialog()
)(AddClientDialog)
